// extracted by mini-css-extract-plugin
export default {"dynamicBanner":"MF-z"};